import { useState, useEffect } from "react";
import { Cake, PartyPopper, CalendarClock } from "lucide-react";
import { api } from "../../lib/api";

export default function AnniversaryAlerts() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/admin/anniversaries").then(({ data }) => setItems(data.anniversaries || []))
      .catch(() => setItems([]));
  }, []);

  if (!items || items.length === 0) return null;

  const when = (d) =>
    d < 0 ? `${Math.abs(d)}d ago` : d === 0 ? "Today" : d === 1 ? "Tomorrow" : `in ${d} days`;

  return (
    <div data-testid="anniversary-alerts" className="rounded-2xl border border-[#c9a961]/40 bg-gradient-to-br from-[#f5f3ec] to-white p-5">
      <div className="flex items-center gap-2">
        <Cake className="h-4 w-4 text-[#a3823f]" />
        <span className="text-[10px] uppercase tracking-[0.26em] text-[#a3823f]">Upcoming Client Anniversaries</span>
      </div>
      <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {items.slice(0, 9).map((a, i) => {
          const soon = a.days_away <= 7;
          return (
            <div key={i} data-testid={`anniversary-${i}`}
              className={`rounded-xl border p-3 ${soon ? "border-[#c9a961] bg-[#c9a961]/10" : "border-[#1e3d3a]/12 bg-white"}`}>
              <div className="flex items-center justify-between gap-2">
                <span className="text-sm font-medium text-[#1e3d3a] truncate">{a.business_name}</span>
                {soon ? <PartyPopper className="h-4 w-4 text-[#a3823f] shrink-0" />
                  : <CalendarClock className="h-4 w-4 text-[#1e3d3a]/40 shrink-0" />}
              </div>
              <div className="mt-1 text-[11px] uppercase tracking-[0.16em] text-[#a3823f]">{a.milestone}</div>
              <div className="mt-1 text-xs text-[#1e3d3a]/55">
                {new Date(a.date).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })}
                <span className={`ml-1.5 font-medium ${soon ? "text-[#a3823f]" : "text-[#1e3d3a]/50"}`}>· {when(a.days_away)}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
